import * as React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { honeyfundLink } from './HoneyfundLink.tsx';
import { CircularProgress, Typography } from '@mui/material';

const sizeAndPosition: React.CSSProperties = {
  border: "0", 
  height: "calc(100vh - 64px)", 
  width: "100vw",
  top: "64px",
};

function LoadingSkeleton() {
  return (
    <Box sx={{
      ...sizeAndPosition,
      position: "absolute",
      alignSelf:"center",
      alignContent: "center",
      textAlign: "center",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 3,
      m: 0,
      px: 0,
      bgcolor: "white"
    }}>
      <Box sx={{width: "70vw", mx: "15vw", alignSelf:"center", position:"static"}}>
        <Box sx={{py: 2}}>
          <Typography component="div" sx={{pb: 2}}>Loading Registry...</Typography>
          <CircularProgress />
        </Box>
        <Skeleton height="50vh" variant="rectangular" />
        <Box sx={{pt: 1}}>
          <Skeleton />
          <Skeleton />
          <Skeleton width="40%" />
        </Box>
      </Box>
    </Box>
  );
}

export default function HoneyfundFrame() {
  const [isLoaded, setIsLoaded] = React.useState(false);

  return (
    <>
      { !isLoaded ? <LoadingSkeleton /> : <></> }
      <iframe src={honeyfundLink}
        width="100%" 
        style={{...sizeAndPosition, position: "fixed"}}
        onLoad={() => setTimeout(() => setIsLoaded(true), 1)}
        />
      </>
  );
}
